import React, { useState, useMemo } from "react";
import Swal from "sweetalert2";
import {
  useStripe,
  useElements,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";

const StripePaymentModal = ({ stripeModalData, onSuccess, onCancel }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);

  const {
    total_amount,
  } = stripeModalData || {};

  // ✅ SAFE CALCULATIONS
 
  const submitPayment = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setLoading(true);

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardNumberElement),
    });

    if (error) {
      Swal.fire("Error", error.message, "error");
      setLoading(false);
      return;
    }

    onSuccess(paymentMethod.id);
    setLoading(false);
  };


  return (
    <form onSubmit={submitPayment}>
      {/* ===== PAYMENT SUMMARY ===== */}

  

      {/* ===== CARD DETAILS ===== */}
      <div className="mb-3">
        <label className="form-label">Card Number</label>
        <CardNumberElement className="form-control p-2" />
      </div>

      <div className="row">
        <div className="col-md-6 mb-3">
          <label className="form-label">Expiry</label>
          <CardExpiryElement className="form-control p-2" />
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label">CVC</label>
          <CardCvcElement className="form-control p-2" />
        </div>
      </div>

      <div className="d-flex justify-content-end gap-3">
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button type="submit" className="btn btn-dark" disabled={loading}>
          {loading ? "Processing..." : `Pay $${total_amount}`}
        </button>
      </div>
    </form>
  );
};

export default StripePaymentModal;
